module.exports = __webpack_public_path__ + "img/page3.a31d909b.png";